<template>
  <div>
    <!-- <img src="http://127.0.0.1:8000/storage/svgs/us-open-22.svg" style="width:100%;float:left;" /> -->
    <!-- <CRow>
      <div style="width:100%;float:left;">
        <pdf-viewer documentUrl="./test.pdf"></pdf-viewer>
      </div>
    </CRow> -->
    <CRow v-if="$store.state.user" class="mb-2">
      <CCol sm="12" class="p-0 text-center">
        <a
          class="btn btn-sm btn-primary mx-1"
          href="https://paiworkflow.com"
          target="_blank"
          rel="noopener noreferrer"
        >Link To Workflow</a>
        <a
          class="btn btn-sm btn-primary mx-1"
          href="https://app.air.inc/a/bT2dcDudx/b/44552d9c-89ae-45e4-b13f-305d0d5b3843"
          target="_blank"
          rel="noopener noreferrer"
        >Link To Air</a>
        <a
          class="btn btn-sm btn-primary mx-1"
          href="https://studio.imperial1916.com"
          target="_blank"
          rel="noopener noreferrer"
        >Link To Studio</a>
      </CCol>
    </CRow>
    <CRow v-if="$store.state.user">
      <CCol class="p-0" sm="12">
        <CCard class="mb-0">
          <CCardBody style="text-align:center;">
            <label style="color:grey;">Customer Showing (leave blank to view all)</label>
            <v-select v-if="customerOptions" @input="customerChanged()" style="width:300px;margin-left:auto;margin-right:auto;" v-model="customer_selected" :options="customerOptions" label="customer_name">
              <template slot="option" slot-scope="option">
                  <!-- <span></span> -->
                      {{option['customer_name']}} - {{option['customer_number']}}
              </template>
              <template slot="selected-option" slot-scope="option">
                  <!-- <span></span> -->
                      {{ option.customer_name }} - {{option.customer_number}}
              </template>
            </v-select>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mt-4" v-if="$store.state.user && !customerLoading && repOrdersLoaded">
      <!-- <CCol sm="6" lg="3">
        <new-orders-widget @set="typeSet"></new-orders-widget>
      </CCol> -->
      <div style="width:100%;float:left;" v-show="!widgetsLoading">
        <!-- <CCol class="float-left" sm="6" lg="3">
          <open-orders-widget :customer_selected="customer_selected" @set="typeSet"></open-orders-widget>
        </CCol> -->
        <CCol class="float-left p-1" sm="3" lg="3">
          <orders-waiting-on-customer :customer_selected="customer_selected" @set="typeSet" ></orders-waiting-on-customer>
        </CCol>
        <CCol class="float-left p-1" sm="3" lg="3" v-if="orders_waiting_on_customer">
          <saved-orders-widget :customer_selected="customer_selected" @set="typeSet"></saved-orders-widget>
        </CCol>
        <!-- <CCol class="float-left p-1" sm="3" md="3" v-if="saved_orders_widget">
          <upcoming-orders-widget :customer_selected="customer_selected" @set="typeSet" headerColor="danger" type="ship_date" title="Needs Shipped < 7 Days"></upcoming-orders-widget>
        </CCol>
        <CCol class="float-left p-1" sm="3" md="3" v-if="upcoming_ship_date">
          <upcoming-orders-widget :customer_selected="customer_selected" headerColor="info" type="event_date" title="Event Orders < 30 Days"></upcoming-orders-widget>
        </CCol> -->
      </div>
      <small-loader v-show="widgetsLoading" />
    </CRow>

    <!-- Rep Open Orders Table -->
    <CRow v-if="$store.state.user && !customerLoading">
      <rep-open-orders :customer_selected="customer_selected" @orders-loaded="repOrdersLoaded = true" :fromDash="true"></rep-open-orders>
    </CRow>


    
    <CRow class="mt-0" v-if="$store.state.user">
      <CCol sm="12" class="p-0" md="12">
        <customer-chart-dash :customer_selected="customer_selected"></customer-chart-dash>
      </CCol>
    </CRow>
    <CRow v-if="$store.state.user && !customerLoading">
      <CCol class="p-0" sm="12">
        <search-orders :send_collapsed="'true'" :customer_selected="customer_selected"></search-orders>
      </CCol>
    </CRow>

    <!-- <CRow v-if="$store.state.user && !customerLoading">
      <rep-orders-dash :customer_selected="customer_selected" @orders-loaded="repOrdersLoaded = true" :fromDash="true"></rep-orders-dash>
    </CRow> -->

   

    <CRow v-if="$store.state.user && !customerLoading">
      <order-history :customer="customer_selected" :fromDash="true"></order-history>
    </CRow>
    <CRow v-if="$store.state.user && !customerLoading">
      
    </CRow>
    <!-- <CRow>
      <csr-table></csr-table>
    </CRow> -->
  </div>
</template>

<script>
import NewOrdersWidget from './new_orders_widget'
import OpenOrdersWidget from './open_orders_widget'
// import OrdersNotifyWidget from './orders_notify_widget'
import OrdersWaitingOnCustomer from './orders_waiting_on_customer_widget'
import CsrTable from './../orders/csr_table'
import PdfViewer from './../components/pdf_viewer'
import OrderHistory from './../components/order_history'
import CustomerChartDash from './../components/customer_chart_dash'
import UpcomingOrders from './../components/upcoming_orders'
import SearchOrders from './../components/search_orders'
import SavedOrdersWidget from './../components/saved_orders_widget'
import UpcomingOrdersWidget from './upcoming_orders_widget'
import RepOpenOrders from '../orders/rep_open_orders.vue'
import RepOrdersDash from './../orders/rep_orders_dash'
var methods = {}

methods.csrChanged = function () {
  console.log('changed')
  this.csrLoading = true
  var that = this
  setTimeout(function () {
    that.csrLoading = false
  }, 500)
}

methods.color = function  (value) {
  let $color
  if (value <= 25) {
    $color = 'info'
  } else if (value > 25 && value <= 50) {
    $color = 'success'
  } else if (value > 50 && value <= 75) {
    $color = 'warning'
  } else if (value > 75 && value <= 100) {
    $color = 'danger'
  }
  return $color
}

methods.typeSet = function  (val) {
  this[val] = true

  if (val === 'saved_orders_widget') {
    this.widgetsLoading = false
  }
}

methods.getRepCustomers = function () {
  axios.post(this.$apiAdress + '/api/getRepCustomers?token=' + localStorage.getItem('api_token')).then(response => {
    // this.customerOptions = response.data
    this.customerOptions = []
    var that = this
    response.data.forEach(function (cust) {
      that.customerOptions.push(cust)
    })
  })
}

methods.customerChanged = function () {
  console.log('changed')
  if (this.customer_selected) {
    localStorage.setItem('customer_dash_selected', JSON.stringify(this.customer_selected))
  } else {
    localStorage.removeItem('customer_dash_selected')
  }
  this.customerLoading = true
  var that = this
  setTimeout(function () {
    that.customerLoading = false
  }, 500)
}

methods.checkCustomer = async function () {
  // if (this.fromDash) {
    if (localStorage.getItem('customer_dash_selected')) {
      this.customer_selected = JSON.parse(localStorage.getItem('customer_dash_selected'))
    }
  // }
  return
}

export default {
  name: 'CSRDashboard',
  components: {
    NewOrdersWidget,
    OpenOrdersWidget,
    // OrdersNotifyWidget,
    CsrTable,
    PdfViewer,
    CustomerChartDash,
    UpcomingOrders,
    SearchOrders,
    SavedOrdersWidget,
    OrdersWaitingOnCustomer,
    UpcomingOrdersWidget,
    OrderHistory,
    RepOpenOrders,
    RepOrdersDash
  },
  data () {
    return {
      new_orders_widget: false,
      open_orders_widget: false,
      orders_notify_widget: false,
      saved_orders_widget: false,
      orders_waiting_on_customer: false,
      upcoming_ship_date: false,
      widgetsLoading: true,
      customerOptions: null,
      customer_selected: '',
      customerLoading: true,
      repOrdersLoaded: false
    }
  },
  mounted: function () {
    this.checkCustomer().then(res => {
      this.customerLoading = false
    })
      this.getRepCustomers()
  },
  methods: methods
}
</script>
